import React, { useState } from "react";
import TrackLimoLogo from "../../assets/tracklimo-logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/fontawesome-free-solid";
import { useDispatch, useSelector } from "react-redux";
// import Footer from "../../components/footer/Footer";
import { setError, setIsLoggedin } from "../../redux/auth/auth-slice";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Bg from "../../assets/bg.jpg";
import { useRef, useEffect } from "react";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const inputRef = useRef(null);

  // selectors
  const { errmsg, isLoggedin } = useSelector((state) => state.auth);

  // states
  const [loginInputField, setloginInputField] = useState({
    companyid: "",
    password: "",
    username: "",
  });

  const [loginStatus, setLoginStatus] = useState(false);
  const [inputErrorMsg, setInputErrorMsg] = useState({
    companyid: "",
    password: "",
    username: "",
  });

  console.log(loginInputField);
  console.log(loginStatus);

  const [isVisible, setisVisible] = useState(false);
  const [isLoginDetailCheck, setisLoginDetailCheck] = useState(false);

  useEffect(() => {
    if (
      loginInputField.companyid &&
      loginInputField.username &&
      loginInputField.password
    ) {
      setLoginStatus(true);
    } else {
      setLoginStatus(false);
    }
  }, [loginInputField]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLoginDetailCheck === false) {
      return toast.warn("please accept the privacy policy");
    }

    dispatch({
      type: "AUTH_LOGIN",
      payload: {
        body: {
          companyid: loginInputField.companyid,
          username: loginInputField.username,
          password: loginInputField.password,
        },
        navigate,
      },
    });
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setloginInputField({ ...loginInputField, [name]: value });
  // };

  const handleInputBlur = (e) => {
    console.log(e.target.name);
    console.log(e.target.value);

    const { name, value } = e.target;
    if (name === "companyid" && value === "") {
      console.log("Please enter your company ID");
      setInputErrorMsg({
        ...inputErrorMsg,
        companyid: "Please enter your company ID",
      });
    } else if (
      name === "username" &&
      value === "" &&
      loginInputField.companyid === ""
    ) {
      console.log("Please enter your username 1");
      setInputErrorMsg({
        ...inputErrorMsg,
        username: "Please enter your username",
      });
    } else if (name === "username" && value === "") {
      console.log("Please enter your username 2");
      setInputErrorMsg({
        ...inputErrorMsg,
        username: "Please enter your username",
      });
    } else if (
      name === "password" &&
      value === "" &&
      loginInputField.username === ""
    ) {
      console.log("Please enter your password");
      setInputErrorMsg({
        ...inputErrorMsg,
        password: "Please enter your password",
      });
    } else if (name === "password" && value === "") {
      console.log("Please enter your password");
      setInputErrorMsg({
        ...inputErrorMsg,
        password: "Please enter your password",
      });
    } else {
      setInputErrorMsg({ ...inputErrorMsg, [name]: "" });
    }
  };

  // const handleInputBlur = (e) => {
  //   const { name, value } = e.target;
  //   if (!value.trim()) {
  //     setInputErrorMsg({
  //       ...inputErrorMsg,
  //       [name]: `${name} is required`,
  //     });
  //   } else if (name === 'companyId' && value !== 'validCompanyId') {
  //     setInputErrorMsg({
  //       ...inputErrorMsg,
  //       [name]: 'Entered wrong Company ID',
  //     });
  //   } else if (name === 'username' && value !== 'validUsername') {
  //     setInputErrorMsg({
  //       ...inputErrorMsg,
  //       [name]: 'Entered wrong Username',
  //     });
  //   } else if (name === 'password' && value !== 'validPassword') {
  //     setInputErrorMsg({
  //       ...inputErrorMsg,
  //       [name]: 'Entered wrong Password',
  //     });
  //   } else {
  //     setInputErrorMsg({
  //       ...inputErrorMsg,
  //       [name]: '',
  //     });
  //   }
  // };

  useEffect(() => {
    // Focus on the first input field when the component mounts
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div className="relative">
      <div className="h-screen w-screen absolute">
        <div className="bg-black opacity-90 absolute w-full h-full"></div>
        <img src={Bg} alt="" className="h-full w-full bg-cover bg-center" />
      </div>

      <div className="space-y-5 sm:space-y-16 xl:space-y-5 relative px-2">
        <Link to="/">
          <div className="flex space-x-2 justify-start mx-5 xs:mx-14 sm:mx-20 md:mx-20 lg:mx-10">
            <img
              src={TrackLimoLogo}
              alt="Tracklimo Logo"
              className="w-48 h-32 sm:w-52 sm:h-24 md:w-60 md:h-32"
            />
          </div>
        </Link>

        {/* <div className="flex justify-center space-x-10 sm:justify-end md:justify-center lg:justify-end mx-5 sm:mx-0 md:mx-0 lg:mx-20 xl:mx-40 2xl:mx-60"> */}
        <div className="flex justify-center lg:space-x-10 sm:justify-center md:justify-center lg:justify-between mx-5 sm:mx-0 md:mx-0 lg:mx-10 xl:mx-24 2xl:mx-52">
          <div className="hidden lg:block mt-5">
            <div className="space-y-3">
              <h2 className="text-4xl text-slate-400 font-thin">Hello,</h2>
              <h3 className="text-6xl text-white font-medium">Welcome Back!</h3>
              {/* <h3 className="w-[600px] lg:w-[460px] text-lg lg:text-base text-white font-thin pt-10 text-justify">Text</h3> */}
            </div>
          </div>
          <div className="relative">
            <div className="w-60 sm:w-80 h-60 sm:h-80 rounded-full bg-gradient-to-b from-[#190061] to-[#0A1B30] absolute -top-10 sm:-top-20 -left-20 md:-top-14 md:-left-32 lg:-left-16 xl:-left-32"></div>
            <div className="w-60 sm:w-80 h-60 sm:h-80 rounded-full bg-gradient-to-b from-[#041248] to-[#0A1B30] absolute -right-6 -bottom-10 sm:-bottom-16 sm:-right-6 md:-bottom-12 md:-right-16 lg:-right-6 lg:-bottom-6 xl:-right-16 xl:-bottom-12"></div>
            <div
              className={`backdrop-blur-md ${
                errmsg
                  ? " border-red-900 loginAlertAnimation"
                  : "bg-slate-800/5"
              }    border border-white/30 w-full sm:w-full md:w-full lg:w-[26.25rem] xl:w-[30rem] rounded-2xl pt-5 sm:pt-10 pb-6 shadow-[rgba(0,0,15,0.5)_0px_5px_4px_10px] `}
            >
              <div className="text-3xl sm:text-4xl px-6 sm:px-10 text-left text-gray-200 font-semibold">
                <h2>Log In</h2>
                <div className="text-base font-normal mt-1">
                  Just some details to get you in!
                </div>
              </div>

              <div className="px-6 sm:px-10 pt-7 space-y-3.5 h-96">
                <div className="relative">
                  <div>
                    <div>
                      <InputField
                        // label="Company ID"
                        type="text"
                        name="companyid"
                        value={loginInputField.companyid}
                        placeholder="Company ID"
                        onChange={(e) => {
                          dispatch(
                            setError({
                              errmsg: "",
                            })
                          );
                          setloginInputField({
                            ...loginInputField,
                            companyid: e.target.value,
                          });
                        }}
                        reference={inputRef}
                        onBlur={(e) => handleInputBlur(e)}
                        error={inputErrorMsg?.companyid}
                        // className={`${
                        //   errmsg ? "border border-red-600" : "hidden"
                        // }`}
                      />
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        className={`${
                          inputErrorMsg?.companyid
                            ? "absolute top-4 right-3 text-red-600"
                            : "hidden"
                        }`}
                      />
                    </div>
                    {inputErrorMsg?.companyid && (
                      <h2
                        className={`${
                          inputErrorMsg?.companyid
                            ? "text-red-600 text-[11px] font-semibold mt-1.5"
                            : "hidden"
                        }`}
                      >
                        {inputErrorMsg.companyid && inputErrorMsg.companyid}
                      </h2>
                    )}
                  </div>
                  {/* <span
                    className={`${
                      errmsg ? "font-medium text-red-600 text-xs" : "hidden"
                    }`}
                  >
                    Please enter your company ID
                  </span> */}
                </div>
                <div>
                  <div className="relative">
                    <div>
                      <InputField
                        // label="Username"
                        type="text"
                        name="username"
                        placeholder="Username"
                        onChange={(e) => {
                          dispatch(
                            setError({
                              errmsg: "",
                            })
                          );
                          setloginInputField({
                            ...loginInputField,
                            username: e.target.value,
                          });
                        }}
                        onBlur={(e) => handleInputBlur(e)}
                        error={inputErrorMsg?.username}
                      />
                      <FontAwesomeIcon
                        icon={faCircleExclamation}
                        className={`${
                          inputErrorMsg.username
                            ? "absolute top-4 right-3 text-red-600"
                            : "hidden"
                        }`}
                      />
                    </div>
                    {inputErrorMsg.username && (
                      <h2
                        className={`${
                          inputErrorMsg.username
                            ? "text-red-600 text-[11px] font-semibold mt-1.5"
                            : "hidden"
                        }`}
                      >
                        {inputErrorMsg.username && inputErrorMsg.username}
                      </h2>
                    )}
                  </div>
                  {/* <span
                    className={`${
                      errmsg ? "font-medium text-red-600 text-xs" : "hidden"
                    }`}
                  >
                    Please enter your username
                  </span> */}
                </div>
                <div>
                  <div className="relative space-y-0.25">
                    <div>
                      {inputErrorMsg.password ? (
                        <FontAwesomeIcon
                          icon={faCircleExclamation}
                          className="absolute top-4 right-3 text-red-600"
                        />
                      ) : (
                        <div className="text-white absolute right-3 top-3">
                          <div
                            className="cursor-pointer text-slate-500"
                            onClick={() => {
                              setisVisible(!isVisible);
                            }}
                          >
                            {isVisible ? (
                              <FontAwesomeIcon icon={faEye} />
                            ) : (
                              <FontAwesomeIcon icon={faEyeSlash} />
                            )}
                          </div>
                        </div>
                      )}
                      <InputField
                        name="password"
                        onChange={(e) => {
                          dispatch(
                            setError({
                              errmsg: "",
                            })
                          );
                          setloginInputField({
                            ...loginInputField,
                            password: e.target.value,
                          });
                        }}
                        type={`${isVisible ? "text" : "password"}`}
                        placeholder="Password"
                        className="bg-transparent border rounded-md px-2 py-3 w-full target:bg-transparent focus:bg-transparent focus:outline-none focus:border-blue-600 text-gray-400 text-sm font-normal"
                        onBlur={(e) => handleInputBlur(e)}
                        error={inputErrorMsg?.password}
                      />
                    </div>
                    {inputErrorMsg.password && (
                      <h2
                        className={`${
                          inputErrorMsg.password
                            ? "text-red-600 text-[11px] font-semibold mt-1.5"
                            : "hidden"
                        }`}
                      >
                        {inputErrorMsg.password && inputErrorMsg.password}
                      </h2>
                    )}
                  </div>
                  {/* <span
                    className={`${
                      errmsg ? "font-medium text-red-600 text-xs" : "hidden"
                    }`}
                  >
                    Please enter your password
                  </span> */}
                </div>
                {/* <div className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    className="bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600"
                  />
                  <h2 className="text-gray-400 text-sm">Remember Me</h2>
                </div> */}
                <div className="flex space-x-3 items-start">
                  <input
                    type="checkbox"
                    className=" bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 mt-1"
                    checked={isLoginDetailCheck}
                    onChange={(e) => {
                      setisLoginDetailCheck(!isLoginDetailCheck);
                    }}
                  ></input>
                  <h2 className="text-gray-400 text-sm">
                    I have read and agreed to the{" "}
                    <Link
                      to="/termsConditions"
                      className="font-medium text-gray-300 underline hover:no-underline"
                    >
                      Terms & Conditions
                    </Link>{" "}
                    & &nbsp;
                    <Link
                      to="/privacyPolicy"
                      className="font-medium text-gray-300 underline hover:no-underline"
                    >
                      Privacy policy
                    </Link>
                  </h2>
                </div>
                <div className="space-y-2">
                  {!isLoggedin ? (
                    <button
                      onClick={
                        // handleSubmit
                        loginInputField.companyid &&
                        loginInputField.username &&
                        loginInputField.password
                          ? handleSubmit
                          : undefined
                      }
                      className={
                        loginStatus === true
                          ? `w-full flex justify-center cursor-pointer bg-gradient-to-r py-2.5 from-[#2f4def] to-[#0110a6] text-xl font-semibold font-inter rounded-md text-white`
                          : `w-full flex justify-center bg-white bg-opacity-25 py-2.5 text-xl font-semibold font-inter rounded-md text-white cursor-not-allowed`
                      }
                      // className={`w-full flex justify-center cursor-pointer bg-gradient-to-r py-2.5 from-[#2f4def] to-[#0110a6] text-xl font-semibold font-inter rounded-md text-white`}
                    >
                      Login
                    </button>
                  ) : (
                    <div className="w-full flex justify-center cursor-pointer bg-gradient-to-r py-2.5 from-[#2f4def] to-[#0110a6] hover:bg-gradient-to-r text-lg font-medium rounded-md text-white">
                      <div className="flex items-center justify-center">
                        <div
                          className="inline-block h-7 w-7 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                          role="status"
                        >
                          <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                            Loading...
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="text-center">
                    <Link
                      to="/forgotpassword"
                      className="cursor-pointer hover:underline text-base text-slate-50"
                    >
                      Forgot Password?
                    </Link>
                  </div>
                </div>
              </div>
              <h2 className="text-center text-white text-xs font-normal font-Inter mt-5 sm:mt-10">
                &copy; Copyright 2024. Tracklimo Pvt Ltd. All rights reserved
              </h2>
            </div>
          </div>
        </div>
        {/* <div className="px-10"><Footer /></div> */}
      </div>
    </div>
  );
};

export default LoginPage;

const InputField = ({
  label,
  type,
  onChange,
  placeholder,
  reference,
  onBlur,
  name,
  error,
}) => {
  console.log(reference, "reference");
  return (
    <>
      <div className="space-y-0.25">
        <div className="text-sm text-gray-200 font-semibold ">{label}</div>
        <input
          name={name}
          onChange={onChange}
          type={type}
          ref={reference}
          placeholder={placeholder}
          onBlur={onBlur}
          className={`bg-transparent border ${
            error ? "border-red-600" : "border-white"
          } rounded-md w-full px-2 py-3 target:bg-transparent focus:outline-none focus:border-blue-600 focus:bg-transparent text-gray-400 text-sm font-normal`}
        />
      </div>
    </>
  );
};
